// extracted by mini-css-extract-plugin
module.exports = {"LoadingContainer":"LoadingIndicator_LoadingContainer__3MZ7B","Spinner":"LoadingIndicator_Spinner__qBDsM","LoadingText":"LoadingIndicator_LoadingText__2xAso"};